/* Afspiller produktvideoen når musen føres hen over den.
   Temaet starter den ellers først når man klikker sig hen på billedet.
   Lyden er slået fra, ellers blokerer browseren automatisk afspilning. */
(function () {
  function bind() {
    var afspillere = document.querySelectorAll('video-player');
    if (!afspillere.length) return false;
    afspillere.forEach(function (vp) {
      if (vp.dataset.hoverBundet) return;
      vp.dataset.hoverBundet = '1';

      vp.addEventListener('mouseenter', function () {
        try {
          if (typeof vp.loadContent === 'function') vp.loadContent();
          if (typeof vp.play === 'function') {
            var pp = vp.play();
            if (pp && pp.catch) pp.catch(function () {});
          }
        } catch (e) {}
        var forsoeg = 0;
        var t = setInterval(function () {
          forsoeg++;
          var v = vp.querySelector('video');
          if (v) {
            v.muted = true;
            v.loop = true;
            v.setAttribute('playsinline', '');
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            clearInterval(t);
          }
          if (forsoeg > 20) clearInterval(t);
        }, 200);
      });

      vp.addEventListener('mouseleave', function () {
        try {
          var v = vp.querySelector('video');
          if (v && typeof v.pause === 'function') v.pause();
          else if (typeof vp.pause === 'function') vp.pause();
        } catch (e) {}
      });
    });
    return true;
  }
  var n = 0;
  (function proev() { n++; if (!bind() && n < 40) setTimeout(proev, 300); })();
  document.addEventListener('shopify:section:load', bind);
})();

/* BT-CUSTOM 2026-10-20 (Michael 15:53): videoer i produktgalleriet skal opføre sig som et billede:
   afspilles automatisk uden lyd, i loop, inline (iOS), og uden synlige knapper/tidslinje.
   Mobilkarrusellen sætter data-controls på afspilleren; det fjernes her, og controls fjernes fra <video>. */
(function () {
  var SEL = 'media-gallery video-player, media-carousel video-player, .media-gallery__item--video video-player';
  if (!document.getElementById('bt-galvid-css')) {
    var s = document.createElement('style'); s.id = 'bt-galvid-css';
    s.textContent = SEL.split(',').map(function (x) { return x.trim() + ' video::-webkit-media-controls,' + x.trim() + ' video::-webkit-media-controls-enclosure,' + x.trim() + ' video::-webkit-media-controls-panel'; }).join(',') + '{display:none!important;-webkit-appearance:none}' +
      SEL.split(',').map(function (x) { return x.trim() + ' .video-play-button,' + x.trim() + ' .plyr__controls'; }).join(',') + '{display:none!important}';
    (document.head || document.documentElement).appendChild(s);
  }
  function fix(vp) {
    if (vp.hasAttribute('data-controls')) vp.removeAttribute('data-controls');
    vp.setAttribute('data-muted', ''); vp.setAttribute('data-loop', ''); vp.setAttribute('data-playsinline', '');
    var v = vp.querySelector('video');
    if (!v) return;
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.loop = true; v.setAttribute('loop', '');
    v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.autoplay = true; v.setAttribute('autoplay', '');
    if (v.hasAttribute('controls')) v.removeAttribute('controls');
    v.controls = false;
    if (!v.dataset.btGal) {
      v.dataset.btGal = '1';
      v.addEventListener('play', function () { if (v.controls) { v.controls = false; v.removeAttribute('controls'); } });
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
  }
  function alle() { document.querySelectorAll(SEL).forEach(fix); }
  alle();
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.type === 'attributes') { var vp = m.target.closest && m.target.closest('video-player'); if (vp && vp.matches(SEL)) fix(vp); }
      else if (m.addedNodes.length) { alle(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['controls', 'data-controls'] });
})();
